import { render, staticRenderFns } from "./DominioResumenComponent.vue?vue&type=template&id=c5d94fce&scoped=true&"
import script from "./DominioResumenComponent.vue?vue&type=script&lang=js&"
export * from "./DominioResumenComponent.vue?vue&type=script&lang=js&"
import style0 from "./DominioResumenComponent.vue?vue&type=style&index=0&id=c5d94fce&scoped=true&lang=css&"
import style1 from "./DominioResumenComponent.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d94fce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VContainer,VForm,VIcon,VRow,VSelect,VTextField})
